import { render, staticRenderFns } from "./BlogPostCategories.vue?vue&type=template&id=95855a54&"
import script from "./BlogPostCategories.vue?vue&type=script&lang=ts&"
export * from "./BlogPostCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports